import React from "react";
import Navbar from "./Components/Navbar/Navbar";
import Hero from "./Components/Hero/Hero";
import About from "./Components/About/About";
import Services from "./Components/Services/Services";
import MyWork from "./Components/MyWork/MyWork";
import GalleryPhotos from "./Components/Gallery/GalleryPhotos";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";

function App() {
  return (
    <div className="w-full min-h-screen overflow-x-hidden">
      <div className="w-full flex flex-col items-center">
        <Navbar />
        <Hero />
        <About />
        <Services />
        <MyWork />
        <GalleryPhotos />
        <Contact />
        <Footer />
      </div>
    </div>
  );
}

export default App;
